import * as env from "@resn/gozer-env"

const createConfig = () => {
  // SETTINGS
  const sharpness = ref(2000)

  const cellSize = ref(env.isMobile ? 0.8 : 0.8)
  const radius = ref(env.isMobile ? 0.0004 : 0.0004)

  // const cellSize = ref(9)
  // const radius = ref(1.4)

  const brightness = ref(0.65)

  // AMBIENT
  const ambientSpeed = ref(0.1)
  const ambientScale = ref(3.5)
  const ambientCutoff = ref(1)
  const ambientStrength = ref(0)
  const ambientMorph = ref(0)
  const ambientDotScale = ref(0)

  const ambientMaskTop = ref(0)
  const ambientMaskBottom = ref(0)
  const ambientMaskCenter = ref(0)

  // FLOW MAP
  const flowMapSize = ref(32)
  const flowMapFalloff = ref(0.35)
  const flowMapDissipation = ref(0.99)
  const flowMapStrength = ref(0)

  // SCALE
  const scaleRadius = ref(300)
  const scaleStrength = ref(1)

  return {
    sharpness,
    cellSize,
    radius,
    brightness,

    ambientSpeed,
    ambientScale,
    ambientCutoff,
    ambientStrength,
    ambientMorph,
    ambientDotScale,

    ambientMaskTop,
    ambientMaskBottom,
    ambientMaskCenter,

    flowMapSize,
    flowMapFalloff,
    flowMapDissipation,
    flowMapStrength,

    scaleRadius,
    scaleStrength,
  }
}

const globalConfig = createConfig()

export const useDots = ({ useGlobal = true } = {}) => {
  const { $gsap } = useNuxtApp()

  const config = useGlobal ? globalConfig : createConfig()

  let timeline = null
  const animateTo = function ({ tl, label, opts, to }) {
    // console.log("useDots.animateTo", to)

    if (timeline) timeline.kill()

    timeline = $gsap.timeline()
    timeline.add("dots")

    for (const [key, value] of Object.entries(to)) {
      // console.log("animateTo", key, value)
      timeline.to(globalConfig[key], { value, ...opts }, "dots")
    }

    if (tl) {
      tl.add(timeline, label)
    }

    return timeline
  }

  return {
    ...config,

    // METHODS
    animateTo,
  }
}
